import type { CreateOneShopImportDto, ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

type AddImportMethodParams = {
	shopImport: CreateOneShopImportDto;
};

export default function useAddImportMethod(shop: ShopDto) {
	return useApiMutation("post", "/shops/{shopId}/imports", {
		mapVariables: ({ shopImport }: AddImportMethodParams) => ({
			params: { path: { shopId: shop.id } },
			body: shopImport,
		}),
	});
}
